export const InternetPolitics =
{
    path: "/InternetPolitics",
    component: () => import("@/views/InternetPolitics/home"),
    meta: {
        hidden: true,
    },
}
export const commonProblem =
{
    path: "/commonProblem",
    component: () => import("@/views/InternetPolitics/commonProblem"),
    meta: {
        hidden: true,
    },
}
export const myPolitics =
{
    path: "/myPolitics",
    component: () => import("@/views/InternetPolitics/myPolitics"),
    meta: {
        hidden: true,
    },
}
export const myRespont =
{
    path: "/myRespont",
    component: () => import("@/views/InternetPolitics/myRespont"),
    meta: {
        hidden: true,
    },
}
export const politicsDetail =
{
    path: "/politicsDetail",
    component: () => import("@/views/InternetPolitics/politicsDetail"),
    meta: {
        hidden: true,
    },
}